import { EBEPaymentMethodsName, EPaymentProvider, PaymentMethod } from '../contracts';

export function getStripeExpressCheckoutPK(paymentMethods: PaymentMethod[]) {
  const cardPM = paymentMethods.find(
    (pm) =>
      pm.provider === EPaymentProvider.stripe && pm.paymentMethodName === EBEPaymentMethodsName.card
  );
  if (cardPM?.pspSubMidPk) {
    return cardPM.pspSubMidPk;
  }
  const googlePM = paymentMethods.find(
    (pm) =>
      pm.provider === EPaymentProvider.stripe &&
      pm.paymentMethodName === EBEPaymentMethodsName.google
  );
  if (googlePM?.pspSubMidPk) {
    return googlePM.pspSubMidPk;
  }
  const applePM = paymentMethods.find(
    (pm) =>
      pm.provider === EPaymentProvider.stripe &&
      pm.paymentMethodName === EBEPaymentMethodsName.apple
  );
  if (applePM?.pspSubMidPk) {
    return applePM.pspSubMidPk;
  }
}
